import * as yup from 'yup';

export const validationSchema = {
  1: yup.object().shape({
    name: yup.string().required('Name is required'),
    email: yup.string().email('Invalid email').required('Email is required'),
    primaryRole: yup.string().required('Primary role is required'),
    organizationType: yup.string().required('Organization type is required'),
    selectedChallenges: yup.array().min(1, 'Please select at least one challenge').required('Please select at least one challenge'),
    otherChallenges: yup.string().optional(),
  }),
  2: yup.object().shape({
    eventTitle: yup.string().optional(),
    eventDate: yup.string().optional(),
    eventTime: yup.string().optional(),
    timeZone: yup.string().optional(),
  }),
};
